import $ from "jquery";
import {Modal} from "bootstrap";
export default function avuCalculator() {
    //Switch Service
    let sliderPositionService = $('input[name="service"]:checked').hasClass('last-radio-for-group') ? 'calc(50% - 1px)' : '1px';
    $('input[name="service"]:checked').closest('.avu-switch').find('.switch-slider').css('right', sliderPositionService);
    //Switch Target
    let sliderPositionTarget = $('input[name="target"]:checked').hasClass('last-radio-for-group') ? 'calc(50% - 1px)' : '1px';
    $('input[name="target"]:checked').closest('.avu-switch').find('.switch-slider').css('left', sliderPositionTarget);
    //on click
    if($('.avu-switch .form-check-input')) {
        $('.avu-switch .form-check-input').each(function() {
            $(this).on('change', function() {
                let sliderPosition = $(this).is(':checked') && $(this).hasClass('last-radio-for-group') ? 'calc(50% - 1px)' : '1px';
                $(this).closest('.avu-switch').find('.switch-slider').css('left', sliderPosition);
            });
        });
    }
    //Beim Laden Anzahl der Personen für Gewerbe ausblenden
    if($('#target2').prop('checked')) {
        $('.avu-person-selector').hide();
        $('.avu-person-selector input').removeAttr('required');
    }
    //Wechsel vom Privat zu Gewerbe
    $('#target2').on('change', function() {
        if ($(this).prop('checked')) {
            $('#kwh1').val(null);
            $('.avu-person-selector').hide();
            $('.avu-person-selector input').removeAttr('required');
        }
    });
    //Wechsel vom Gewerbe zu Privat
    $('#target1').on('change', function() {
        if ($(this).prop('checked')) {
            let kwhValue = null;
            if($('input[name="service"]:checked').attr('data-service') == 'STROM'
                || ($('.serviceIn').length > 0  && $('.serviceIn').attr('data-service') == 'STROM')) {
                kwhValue = $('input[name="persons"]:checked').attr('data-kwh-strom');

            }
            if($('input[name="service"]:checked').attr('data-service') == 'ERDGAS'
                || ($('.serviceIn').length > 0 && $('.serviceIn').attr('data-service') == 'ERDGAS')) {
                kwhValue = $('input[name="persons"]:checked').attr('data-kwh-erdgas');
            }
            $('#kwh1').val(kwhValue);
            $('.avu-person-selector').show();
            $('.avu-person-selector input').attr('required', 'required');
        }
    });
    //Änderung der kWh beim Ändern der Anzahl an Personen
    $('input[name="persons"]').change(function() {
        if($('input[name="service"]:checked').attr('data-service') == 'STROM'
            || ($('.serviceIn').length > 0  && $('.serviceIn').attr('data-service') == 'STROM')) {
            let selectedKwh = $(this).attr('data-kwh-strom');
            $('#kwh1').val(selectedKwh);
        }
        if($('input[name="service"]:checked').attr('data-service') == 'ERDGAS'
            || ($('.serviceIn').length > 0 && $('.serviceIn').attr('data-service') == 'ERDGAS')) {

            let selectedKwh = $(this).attr('data-kwh-erdgas');
            $('#kwh1').val(selectedKwh);
        }
    });
    //Weiterleitungen abhängig vom Context (Startseite, Stromseite oder Erdgasseite)
    //Geschäftskundenseiten
    if(window.location.href.includes('geschaeftskunden')) {
        $('#target1').attr('checked', false);
        $('#target2').attr('checked', true);
        let sliderPositionTarget = $('input[name="target"]:checked').hasClass('last-radio-for-group') ? 'calc(50% - 1px)' : '1px';
        $('input[name="target"]:checked').closest('.avu-switch').find('.switch-slider').css('left', sliderPositionTarget);
        $('.avu-person-selector').hide();
        $('.avu-person-selector input').removeAttr('required');

    }
    //Vorbelegung des Input-Fields für kWh mit passenden Werte beim Laden
    if($('input[name="persons"]')
        && $('input[name="kwh"]')
        && $('input[name="kwh"]').val() == "") {
        let kwhValue = null;
        if($('.serviceIn').attr('value') == "POWER" || $('input[name="service"]:checked').attr('value') == "POWER"){
            if($('input[name="target"]:checked').attr('value') == "PRIVATE" || $('.targetIn').attr('value') == "PRIVATE") {
                if($('#kwh1').attr('data-val-private')) {
                    kwhValue = $('#kwh1').attr('data-val-private');
                } else {
                    kwhValue = $('input[name="persons"]:checked').attr('data-kwh-strom');
                }
            }
            if($('input[name="target"]:checked').attr('value') == "BUSINESS" || $('.targetIn').attr('value') == "BUSINESS") {
                if($('#kwh1').attr('data-val-business')) {
                    kwhValue = $('#kwh1').attr('data-val-business');
                } else {
                    kwhValue = null;
                }
            }
        }
        if($('.serviceIn').attr('value') == "GAS" || $('input[name="service"]:checked').attr('value') == "GAS") {
            if($('input[name="target"]:checked').attr('value') == "PRIVATE" || $('.targetIn').attr('value') == "PRIVATE") {
                if($('#kwh1').attr('data-val-private')) {
                    kwhValue = $('#kwh1').attr('data-val-private');
                } else {
                    kwhValue = $('input[name="persons"]:checked').attr('data-kwh-erdgas');
                }
            }
            if($('input[name="target"]:checked').attr('value') == "BUSINESS" || $('.targetIn').attr('value') == "BUSINESS" ) {
                if($('#kwh1').attr('data-val-business')) {
                    kwhValue = $('#kwh1').attr('data-val-business');
                } else {
                    kwhValue = null;
                }
            }
        }
        $('#kwh1').attr("value", kwhValue);
    }
    //Vorbelegung des Input-Fields für kWh mit passenden Werte beim Wechseln zwischen Strom und Erdgas und umgekehrt
    $('input[name="service"]').change(function() {
        if ($('input[name="service"]:checked').attr('data-service')== 'STROM'
            && $('input[name="target"]:checked').attr('data-target') == 'PRIVAT') {
            let selectedKwh = $('input[name="persons"]:checked').attr('data-kwh-strom');
            $('#kwh1').val(selectedKwh);
        }
        if ($('input[name="service"]:checked').attr('data-service') == 'ERDGAS'
            && $('input[name="target"]:checked').attr('data-target') == 'PRIVAT') {
            let selectedKwh = $('input[name="persons"]:checked').attr('data-kwh-erdgas');
            $('#kwh1').val(selectedKwh);
        }
    });

    let service = null;
    if($('input[name="service"]').attr('type') == 'radio') {
        service = $('input[name="service"]:checked').attr('data-service');
    } else {
        service = $('input[name="service"]').attr('data-service');
    }
    let target = $('input[name="target"]:checked').attr('data-target');

    $('input[name="service"]').change(function() {
        service = $(this).attr('data-service');
        target = $('input[name="target"]:checked').attr('data-target');
    });
    $('input[name="target"]').change(function(){
        target= $(this).attr('data-target');
        service = null;
        if($('input[name="service"]').attr('type') == 'radio') {
            service = $('input[name="service"]:checked').attr('data-service');
        } else {
            service = $('input[name="service"]').attr('data-service');
        }
    });

    function defineAction() {
        //hier routes anpassen
        let isgreen = $('input[name="greentariff"]').val();
        if(service === 'STROM'){
            if(target === "PRIVAT" && isgreen === "notgreen") {
                $('.avu-form-tarifrechner-form').attr('action', '/strom/#preise');
            }
            if(target === "BUSINESS" && isgreen === "notgreen") {
                $('.avu-form-tarifrechner-form').attr('action', '/geschaeftskunden/strom/#preise');
            }
            if(target === "PRIVAT" && isgreen === "isgreeen") {
                $('.avu-form-tarifrechner-form').attr('action', '/strom/gruenstrom/#preise');
            }
            if(target === "BUSINESS" && isgreen === "isgreeen") {
                $('.avu-form-tarifrechner-form').attr('action', '/geschaeftskunden/strom/gruenstrom/#preise');
            }

        } else if(service === 'ERDGAS'){
            if(target === "PRIVAT" && isgreen === "notgreen") {
                $('.avu-form-tarifrechner-form').attr('action', '/erdgas/#preise');
            }
            if(target === "BUSINESS" && isgreen === "notgreen") {
                $('.avu-form-tarifrechner-form').attr('action', '/geschaeftskunden/erdgas/#preise');
            }
            if(target === "PRIVAT" && isgreen === "isgreeen") {
                $('.avu-form-tarifrechner-form').attr('action', '/erdgas/gruengas/#preise');
            }
            if(target === "BUSINESS" && isgreen === "isgreeen") {
                $('.avu-form-tarifrechner-form').attr('action', '/geschaeftskunden/erdgas/gruengas/#preise');
            }
        }
    }

    let tarifState = false;

    $("#avu-calculation").click(function(event) {
        if($(this).hasClass('avu-calculation-single') == false) {
            defineAction();
        }
    });

    //WICHTIG ACTIVIEREN MIT TARIFRECHNER
   $("#avu-calculation").click(function(event) {
            event.preventDefault();
            let loadingSpinner = $('#loading-spinner-tariff');
            let mediaType = $('input[name="service"]:checked').val();
            let mediaTypeSingle = $('.serviceIn').val();
            let targetType =  $('input[name="target"]:checked').val();
            let targetTypeSingle = $('.targetIn').val();
            let serviceSelector1 = $('#service1').val();
            let serviceSelector2 = $('#service2').val();
            let serviceState = false;
            let targetSelector1 = $('#target1').val();
            let targetSelector2 = $('#target2').val();
            let targetState = false;
            let personSelector1 = $('#persons1').val();
            let personSelector2 = $('#persons2').val();
            let personSelector3 = $('#persons3').val();
            let personSelector4 = $('#persons4').val();
            let personSelector5 = $('#persons5').val();
            let personState = false;
            let zipState = false;
            let zipPlaceState = false;
            let limitStateOk = false;
            let zipCodeValue = $('input[name="zip"]').val();
            let kwhState = false;
            let kwhValue = $('input[name="kwh"]').val();
            let regex = /^[0-9]+$/;
            let green = $('input[name="greentariff"]').val();
            let greenState = false;


            if(green == 'isgreeen' || green == 'notgreen' || green == undefined) {
                greenState = true;
                $('.error-variant').text("");
            }
            else {
                $('.error-variant').text("Es ist ein Fehler aufgetreten.");
            }

            if(serviceSelector1 != undefined && serviceSelector2 != undefined) {
                if (serviceSelector1 == "POWER" && serviceSelector2 == "GAS") {
                    serviceState = true;
                    $('.error-service').text("");
                }
                else {
                    $('.error-service').text("Bitte wählen Sie Strom oder Erdgas aus.");
                }
            }
            else {
                $('.error-service').text("Bitte wählen Sie Strom oder Erdgas aus.");
            }
            if(serviceSelector1 != undefined && serviceSelector2 == undefined) {
                if (serviceSelector1 == "POWER") {
                    serviceState = true;
                    $('.error-service').text("");
                }
            }
            if(serviceSelector1 == undefined && serviceSelector2 != undefined) {
                if (serviceSelector2 == "GAS") {
                    serviceState = true;
                    $('.error-service').text("");
                }
            }
           if(targetSelector1 == "PRIVATE" || targetSelector2  == "BUSINESS") {
               targetState = true;
               $('.error-target').text("");
           }
           else {
               $('.error-target').text("Bitte wählen Sie Privat oder Gewerbe aus.");
           }
           if(personSelector1  == "1"
               && personSelector2  == "2"
               && personSelector3  == "3"
               && personSelector4  == "4"
               && personSelector5  == "5"
           ) {
               personState = true;
               $('.error-person').text("");
           }
           else {
               $('.error-person').text("Bitte eine passende Anzahl auswählen.");
           }

           if(regex.test(kwhValue)) {
               kwhState = true;
               $('.error-kwh').text("");
           } else {
               $('.error-kwh').text("Die kWh/Jahr müssen numerisch sein.");
               if(kwhValue == "") {
                   $('.error-kwh').text("kWh/Jahr ist ein Pflichtfeld.");
               }
           }

           if (regex.test(zipCodeValue)) {
               zipState = true;
               $('.error-zip').text("");
           }
           else {
               loadingSpinner.show();
               if(zipCodeValue == "") {
                   loadingSpinner.hide();
                   $('.error-zip').text("Die Postleitzahl ist ein Pflichtfeld.");
               } else {
                   loadingSpinner.hide();
                   $('.error-zip').text("Die Postleitzahl muss numerisch sein.");
               }
           }

           if(serviceState == true && targetState == true && personState == true && kwhState == true && zipState == true && greenState == true) {
           loadingSpinner.show();
           $.ajax({
               type: 'POST',
               url: ajaxurl,
               data: {
                   action: 'itc_request',
                   zip: zipCodeValue,
                   mediaType: mediaType
               },
               success: function (response) {
                   response = JSON.parse(response);
                   let limitPowerPrivate = parseFloat(response.limit_power_private);
                   let limitGasPrivate = parseFloat(response.limit_gas_private);
                   let limitPowerBusiness = parseFloat(response.limit_power_business);
                   let limitGasBusiness = parseFloat(response.limit_gas_business);
                   let inputKwh = parseFloat($('#kwh1').val());
                   //zip check
                   if (response.itc == "0") {
                       $('.error-zip').text("Die Postleitzahl befindet sich außerhalb des Liefergebiets.");
                       loadingSpinner.hide();
                   } else {
                       zipPlaceState = true;
                       $('.error-zip').text("");
                   }

                   //limit check: power
                   if(mediaType == 'POWER' || mediaTypeSingle == 'POWER') {
                       //limit check: power + private
                       if(targetType == 'PRIVATE' || targetTypeSingle == 'PRIVATE') {
                           if(inputKwh >= limitPowerPrivate) {
                               limitStateOk == false;
                               loadingSpinner.hide();
                               let limitModalID = $('#modalCalculatorLimitPowerPrivate');
                               let limitModal = new Modal(limitModalID);
                               if(limitModal) {
                                   limitModal.show();
                               }
                           } else {
                               limitStateOk = true;
                           }
                       }
                       //limit check: power + business
                       if(targetType == 'BUSINESS' || targetTypeSingle == 'BUSINESS') {
                           if(inputKwh >= limitPowerBusiness) {
                               limitStateOk == false;
                               loadingSpinner.hide();
                               let limitModalID = $('#modalCalculatorLimitPowerBusiness');
                               let limitModal = new Modal(limitModalID);
                               if(limitModal) {
                                   limitModal.show();
                               }
                           }
                           else {
                               limitStateOk = true;
                           }
                       }
                   }
                   //limit check: gas
                   if((mediaType == 'GAS' || mediaTypeSingle == 'GAS')) {
                       //limit check: gas + private
                       if(targetType == 'PRIVATE' || targetTypeSingle == 'PRIVATE') {
                           if(inputKwh >= limitGasPrivate) {
                               limitStateOk == false;
                               loadingSpinner.hide();
                               let limitModalID = $('#modalCalculatorLimitGasPrivate');
                               let limitModal = new Modal(limitModalID);
                               if(limitModal) {
                                   limitModal.show();
                               }
                           }
                           else {
                               limitStateOk = true;
                           }
                       }
                       if(targetType == 'BUSINESS' || targetTypeSingle == 'BUSINESS') {
                           if(inputKwh >= limitGasBusiness) {
                               limitStateOk == false;
                               loadingSpinner.hide();
                               let limitModalID = $('#modalCalculatorLimitGasBusiness');
                               let limitModal = new Modal(limitModalID);
                               if(limitModal) {
                                   limitModal.show();
                               }
                           }
                           else {
                               limitStateOk = true;
                           }
                       }
                   }
               },
               error: function(){
                   $('.error-timeout').text("Es konnte keine  Verbindung aufgebaut werden. Versuchen Sie später nochmal.");
                   loadingSpinner.hide();
               },
               timeout: 60000

           }).done(function (response) {
               if(zipPlaceState == true && limitStateOk == true) {
                    if($(this).hasClass('avu-calculation-single') == false) {
                        defineAction();
                    }
                   let dlService = "";
                   let dlTarget = "";
                   let dlPersons = "";
                   let htmlPerson = $('input[type="radio"][name="persons"]:checked').val();
                   if(mediaType) {
                       if(mediaType == "POWER") {
                           dlService = "Strom";
                       }
                       if(mediaType == "GAS") {
                           dlService = "Erdgas";
                       }
                   } else {
                       if(mediaTypeSingle) {
                           if(mediaTypeSingle == "POWER") {
                               dlService = "Strom";
                           }
                           if(mediaTypeSingle == "GAS") {
                               dlService = "Erdgas";
                           }
                       }
                   }
                   if(targetType) {
                       if(targetType == "PRIVATE") {
                           dlTarget = "Privat";
                       }
                       if(targetType == "BUSINESS") {
                           dlTarget = "Gewerbe";
                       }
                   } else {
                       if(targetTypeSingle) {
                           if(targetTypeSingle == "PRIVATE") {
                               dlTarget = "Privat";
                           }
                           if(targetTypeSingle == "BUSINESS") {
                               dlTarget = "Gewerbe";
                           }
                       }
                   }

                   if(targetType == "PRIVATE" || targetTypeSingle == "PRIVATE") {
                       if (htmlPerson) {
                           if (parseInt(htmlPerson) == 1) {
                               dlPersons = htmlPerson + ' Person';
                           }
                           if (parseInt(htmlPerson) > 1 && parseInt(htmlPerson) <= 4) {
                               dlPersons = htmlPerson + ' Personen';
                           }
                           if (parseInt(htmlPerson) >= 5) {
                               dlPersons = 'Mehr als 4 Personen';
                           }
                       }
                   }
                   if(targetType == "BUSINESS" || targetTypeSingle == "BUSINESS") {
                       dlPersons = 'keine Angabe für Gewerbe';
                   }
                   let buttonTariffName = "";
                   if($('.avu-calculation-single')) {
                       buttonTariffName = $('.avu-calculation-single').attr("data-button-tariff-name");
                   }
                   const dataLayerObject = {
                       'event': 'tariff_calculator',
                       'tariff_calculator': true,
                       'start_path': window.location.href,
                       'product_typ': dlService,
                       'target_group': dlTarget,
                       'postcode': zipCodeValue,
                       'number_of_persons': dlPersons,
                       'consumption': parseInt(kwhValue)
                   };
                   if (buttonTariffName !== "" && buttonTariffName !== undefined) {
                       dataLayerObject['tariff_name'] = buttonTariffName;
                   }
                   window.dataLayer = window.dataLayer || [];
                   dataLayer.push(dataLayerObject);
                   $("#avu-form-tarifrechner").submit();
               }
           });
       }

    });

    //Klonen Tarifrechner für modal
    $(".open-tarifrechner").click(function(){
        //Klone erstellen
        let tarifrechnerContent = $(".avu-tarifrechner").clone(true);
        //Tarifrechner kopieren in modal-body
        $("#tariffCalculationModal .modal-body").empty().append(tarifrechnerContent);
    });
    let ModalTariff = document.getElementById('tariffCalculationModal');
    if(ModalTariff) {
        ModalTariff.addEventListener('hidden.bs.modal', function (event) {
            //Tarifrechner entfernen aus dem Modal
            $(this).find(".modal-body").empty();
        })
    }


    //Meldung für Business-Kunden
    $(".avu-tarifrechner-question-business #avu-tariff-is-private").click(function(){
        $(".avu-tarifrechner-question-business").css( "opacity","0");
        setTimeout(() => {
            $(".avu-tarifrechner-question-business").css( "z-index","-500");
            $(".avu-tarifrechner-question-business").css( "display","none");
        }, 500);

    });
    let typingTimer;
    let doneTypingInterval = 500;
    $('#kwh1').on('input', function() {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(doneTyping, doneTypingInterval);
    });
    function doneTyping() {
        if($('#kwh1').val() >= 100000) {
            $(".avu-tarifrechner-question-business").css( "display","block");
            //Wenn nur einmal vorkommen soll dies löschen
            $(".avu-tarifrechner-question-business").css( "z-index","500");
            $(".avu-tarifrechner-question-business").css( "opacity","1");
        } else {
            $(".avu-tarifrechner-question-business").css( "display","none");
        }
    }

    //Ökovariante
    $('.avu-cbx-eco-tariff').on('click', function() {
        let $tariffPriceEco = $(this).closest('div').siblings('.tariff-price-eco');
        let $tariffPrice = $(this).closest('div').siblings('.tariff-price');

        if ($(this).is(':checked')) {
            $tariffPriceEco.removeClass('d-none');
            $tariffPrice.addClass('d-none');
        } else {
            $tariffPriceEco.addClass('d-none');
            $tariffPrice.removeClass('d-none');
        }
    });
    $('.avu-cbx-eco-tarif-single').on('click', function() {
            if($('.ecological-tarif').hasClass('d-none')) {
                $('.ecological-tarif').removeClass('d-none');
                $('.conventional-tarif').addClass('d-none');
            } else {
                $('.ecological-tarif').addClass('d-none');
                $('.conventional-tarif').removeClass('d-none');
            }
    });

    if ($('.avu-swiper-wrapper-tariff').length > 0) {
        const items = [];
        $('.avu-swiper-wrapper-tariff .swiper-slide').each(function () {
            const button = $(this).find('button.tariff-button');
            if (button.length > 0) {
                const tariffId = button.data('tariff-id');
                const tariffName = button.data('tariff-name');
                const tariffVariant = button.data('tariff-variant');
                const tariffPrice = button.data('tariff-price');
                if (tariffId && tariffName && tariffVariant && tariffPrice) {
                    items.push({
                        item_id: tariffId,
                        item_name: tariffName,
                        index: items.length + 1,
                        item_variant: tariffVariant,
                        price: tariffPrice
                    });
                }
            }
        });

        if (items.length > 0) {
            dataLayer.push({
                event: 'view_item_list',
                items: items
            });
        }
    }
    $('.tariff-button').on('click', function(event){
        event.stopPropagation();
        if($(this).hasClass('not-for-new-customer')) {
            $('#new-customer-tariff-url').addClass('d-none');
        } else {
            $('#new-customer-tariff-url').removeClass('d-none');
        }
        let bookingModalID = $('#tariffBookingList');
        let bookingModal = new Modal(bookingModalID);
        if(bookingModal) {
            bookingModal.show();
        }
        let dataTariffName = $(this).data('tariff-name');
        let dataNumberPersons = $(this).data('number-persons');
        let dataTariffId = '&productId=' + $(this).data('tariff-id');
        let dataCustomerType = '&customerType=' + $(this).data('customer-type');
        let dataMediaType = '&mediaType=' + $(this).data('media-type');
        let dataConsumption = '&consumption=' + $(this).data('consumption');
        let dataZip = '&postalCode=' + $(this).data('zip');
        let dataCity = '&city=' + $(this).data('city');
        let dataSearch = '&productSearch=true';
        let bookingText = $(this).closest('.swiper-slide-content').find('.tariff-booking-desc').text();
        let liveUrl = 'https://portal.avu.de/powercommerce/avu/fo/portal/';
        let newCustomerAPI = 'directContractCreation';
        let customerWithLoginAPI = 'externalProductChange';
        let stp = 'stp=1';
        let dlPrice = parseFloat($(this).data('tariff-price'));
        let dlId = $(this).data('tariff-id');
        let dlVariant = $(this).data('tariff-variant');
        let dlProdMediaType = "";
        let dlProdTargetType = "";
        let dlZip = ""+$(this).data('zip')+"";
        let finalUrlNewCustomer = liveUrl + newCustomerAPI + '?' + stp +dataTariffId + dataCustomerType + dataMediaType + dataConsumption + dataZip + dataCity + dataSearch;
        $('#new-customer-tariff-url').attr("href", finalUrlNewCustomer);
        let finalUrlLoginCustomer = liveUrl + customerWithLoginAPI + '?' + stp + dataTariffId + dataCustomerType + dataMediaType + dataConsumption + dataZip + dataCity;
        $('#customer-login-url').attr("href", finalUrlLoginCustomer);
        $('.modal-tariff-name').text(dataTariffName);
        $('.modal-tariff-desc').text(bookingText);

        if($(this).data('media-type') == 'POWER') {
            dlProdMediaType = 'Strom';
        }
        if($(this).data('media-type') == 'GAS') {
            dlProdMediaType = 'Erdgas';
        }
        if($(this).data('customer-type') == 'PRIVATE') {
            dlProdTargetType = 'Privat';
        }
        if($(this).data('customer-type') == 'BUSINESS') {
            dlProdTargetType = 'Gewerbe';
        }
        let prodButtonSelector = $('#new-customer-tariff-url, #customer-login-url, #customer-without-login');
        prodButtonSelector.attr("data-price", dlPrice);
        prodButtonSelector.attr("data-tariff-id", dlId);
        prodButtonSelector.attr("data-tariff-name", dataTariffName);
        prodButtonSelector.attr("data-green-energy", $(this).data('tariff-variant'));
        prodButtonSelector.attr("data-product-typ", dlProdMediaType);
        prodButtonSelector.attr("data-target-group", dlProdTargetType);
        prodButtonSelector.attr("data-postcode", dlZip);
        prodButtonSelector.attr("data-consumption", parseInt($(this).data('consumption')));
        prodButtonSelector.attr("data-number-persons", dataNumberPersons);

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'tariff_selection',
            'tariff_selection' : true,
            'tariff_name' : dataTariffName,
            'green_energy' : dlVariant,
            'price' : dlPrice,
            'start_path' : window.location.href,
            'product_typ': dlProdMediaType,
            'target_group' : dlProdTargetType,
            'number_of_persons': dataNumberPersons,
            'postcode' : dlZip,
            'consumption' : parseInt($(this).data('consumption'))
        });
        dataLayer.push({
            event: 'select_item',
            items: [{
                index: 1,
                item_id: dlId,
                item_name: dataTariffName,
                item_variant: dlVariant,
                price: dlPrice
            }],
            currency: 'EUR',
            value: dlPrice
        });
    });
    $('a.tariff-booking-button').on('click', function(event) {
        event.preventDefault();
        const items = [];
        const button = $(this);
        let linkURL = $(this).attr('href');
        if (button.length > 0) {
            const tariffId = button.data('tariff-id');
            const tariffName = button.data('tariff-name');
            const tariffVariant = button.data('green-energy');
            const tariffPrice = button.data('price');
            if (tariffId && tariffName && tariffVariant && tariffPrice) {
                items.push({
                    item_id: tariffId,
                    item_name: tariffName,
                    index: items.length + 1,
                    item_variant: tariffVariant,
                    price: tariffPrice
                });
            }
        }
        if (items.length === 1) {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                event: 'add_to_cart',
                items: items,
                currency: 'EUR',
                value: items[0].price
            });
        }
        window.location.href = linkURL;
    });
    //Datenschicht neukunde
    $('#new-customer-tariff-url, .tariff-booking-button-new-customer').on('click', function(event){
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'customer_type',
            'customer_type' : "Neukunde",
            'tariff_name' : $(this).attr('data-tariff-name'),
            'green_energy' : $(this).attr('data-green-energy'),
            'price' : parseFloat($(this).attr('data-price')),
            'start_path' : window.location.href,
            'product_typ': $(this).attr('data-product-typ'),
            'target_group' : $(this).attr('data-target-group'),
            'postcode' : $(this).attr('data-postcode'),
            'number_of_persons': $(this).attr('data-number-persons'),
            'consumption' : parseInt($(this).attr('data-consumption'))
        });
    });
    //Datenschicht Kunde mit Login
    $('#customer-login-url, .tariff-booking-button-customer-login').on('click', function(event){
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'customer_type',
            'customer_type' : "Kunde mit Login",
            'tariff_name' : $(this).attr('data-tariff-name'),
            'green_energy' : $(this).attr('data-green-energy'),
            'price' : parseFloat($(this).attr('data-price')),
            'start_path' : window.location.href,
            'product_typ': $(this).attr('data-product-typ'),
            'target_group' : $(this).attr('data-target-group'),
            'postcode' : $(this).attr('data-postcode'),
            'number_of_persons': $(this).attr('data-number-persons'),
            'consumption' : parseInt($(this).attr('data-consumption'))
        });
    });
    //Datenschicht Kunde ohne Login
    $('#customer-without-login, .tariff-booking-button-customer-no-login').on('click', function(event){
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'customer_type',
            'customer_type' : "Kunde ohne Login",
            'tariff_name' : $(this).attr('data-tariff-name'),
            'green_energy' : $(this).attr('data-green-energy'),
            'price' : parseFloat($(this).attr('data-price')),
            'start_path' : window.location.href,
            'product_typ': $(this).attr('data-product-typ'),
            'target_group' : $(this).attr('data-target-group'),
            'postcode' : $(this).attr('data-postcode'),
            'number_of_persons': $(this).attr('data-number-persons'),
            'consumption' : parseInt($(this).attr('data-consumption'))
        });
    });
    $('#tariff-eco-variant-single').on('click', function(event){
        if($(this).is(':checked')) {
            let tariffNameGreen = $('.tariff-booking-button-single').attr('data-tariff-name') +" Grün";
            $('.tariff-booking-button-single').attr('data-tariff-name',tariffNameGreen);
            $('.tariff-booking-button-single').attr("data-tariff-variant", "Ökostrom");
        } else {
            let tariffName = $('.tariff-booking-button-single').attr('data-tariff-name').replace(" Grün", "");
            $('.tariff-booking-button-single').attr('data-tariff-name',tariffName);
            $('.tariff-booking-button-single').attr("data-tariff-variant", "Kein Ökostrom");
        }
    });

    $('.tariff-booking-button-single').on('click', function(event){
        if($(this).hasClass('not-for-new-customer')) {
            $('.tariff-booking-button-new-customer').addClass('d-none');
        } else {
            $('.tariff-booking-button-new-customer').removeClass('d-none');
        }
        let buttonSelector = $('.tariff-booking-button-new-customer, .tariff-booking-button-customer-no-login, .tariff-booking-button-customer-login');
        buttonSelector.attr("data-customer-type", $(this).attr('data-customer-type'));
        buttonSelector.attr("data-tariff-name", $(this).attr('data-tariff-name'));
        buttonSelector.attr("data-green-energy", $(this).attr('data-tariff-variant'));
        buttonSelector.attr("data-product-typ", $(this).attr('data-media-type'));
        buttonSelector.attr("data-target-group", $(this).attr('data-customer-type'));
        buttonSelector.attr("data-postcode", $(this).attr('data-zip'));
        buttonSelector.attr("data-consumption", parseInt($(this).attr('data-consumption')));
        buttonSelector.attr("data-price", parseFloat($(this).attr('data-tariff-price').replace('€', '').replace(',', '.').trim()));
        buttonSelector.attr("data-number-persons", $(this).attr('data-number-persons'));

        const dataTariffId = $(this).data('tariff-id');
        const dataTariffName = $(this).data('tariff-name');
        const dataTariffVariant = $(this).data('tariff-variant');
        const dataTariffPrice = parseFloat($(this).attr('data-tariff-price').replace('€', '').replace(',', '.').trim());

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'tariff_selection_product_page',
            'tariff_selection_product_page' : true,
            'customer_type' : $(this).attr('data-customer-type'),
            'tariff_name' : dataTariffName,
            'green_energy' : $(this).attr('data-tariff-variant'),
            'price' : dataTariffPrice,
            'start_path' : window.location.href,
            'product_typ': $(this).attr('data-media-type'),
            'target_group' : $(this).attr('data-customer-type'),
            'postcode' : $(this).attr('data-zip'),
            'number_of_persons': $(this).attr('data-number-persons'),
            'consumption' : parseInt($(this).attr('data-consumption'))
        });
        dataLayer.push({
            event: 'select_item',
            item_list_name: 'Tariff selection',
            items: [{
                index: 1,
                item_id: dataTariffId,
                item_name: dataTariffName,
                item_variant: dataTariffVariant,
                price: dataTariffPrice
            }],
            currency: 'EUR',
            value: dataTariffPrice
        });
    });


}

//avoid double resubmission of the form
if ( window.history.replaceState ) {
    window.history.replaceState( null, null, window.location.href );
}
$('.go-to-calculator-business').on('click', function(event){
    event.preventDefault();
    const formData = {};
    $('#avu-form-tarifrechner').find('input[name="zip"], input[name="kwh"]').each(function() {
        formData[$(this).attr('name')] = $(this).val();
    });
    localStorage.setItem('formData', JSON.stringify(formData));
    window.location.href = $(this).attr("href")
});


const formData = JSON.parse(localStorage.getItem('formData'));
if (formData) {
    for (let name in formData) {
        $(`[name="${name}"]`).prop('value', formData[name]);
    }
    localStorage.removeItem('formData');
    let navigationHeight = 420;
    let zoomLevel = window.devicePixelRatio * 100;
    if(zoomLevel >= 99) {
        navigationHeight = 420;
    }
    if(zoomLevel >= 89 && zoomLevel < 99) {
        navigationHeight = 520;
    }
    if(zoomLevel >= 79 && zoomLevel < 89) {
        navigationHeight = 600;
    }
    if(zoomLevel >= 67 && zoomLevel < 79) {
        navigationHeight = 700;
    }
    if(zoomLevel >= 50 && zoomLevel < 67) {
        navigationHeight = 1000;
    }
    let elementOffset = $('#avu-calculator').offset().top;
    let elementHeight = $('#avu-calculator').outerHeight();
    let windowHeight = $(window).height();
    let scrollToPosition = 0;
    if(window.innerWidth > 992) {
        scrollToPosition = elementOffset - navigationHeight + (windowHeight - elementHeight) / 2;
    } else {
        scrollToPosition = elementOffset - 250 + (windowHeight - elementHeight) / 2;
    }
    $('html').animate({
        scrollTop: scrollToPosition
    }, 0, function() {
        $('#avu-calculator').css({
            'transition': 'transform 2s',
            'transform': 'scale(1.2)'
        });

        setTimeout(function() {
            $('#avu-calculator').css({
                'transform': 'scale(1)'
            });
        }, 1000);
    });
}

$('.tariff-recalculate').on('click', function() {
    let currentUrl = window.location.href;
    let baseUrl = currentUrl.split('?')[0];
    window.location.href = baseUrl;
});
